export const UPDATE_REPORT = 'UPDATE_REPORT';
export const RESET_REPORT = 'RESET_REPORT';